import { useEffect } from 'react';
import type { TenantAuditEntry } from '../../api/types.js';

interface Props {
  entry: TenantAuditEntry;
  onClose: () => void;
}

export function AuditRowDrawer({ entry, onClose }: Props) {
  useEffect(() => {
    function onKey(e: KeyboardEvent) {
      if (e.key === 'Escape') onClose();
    }
    window.addEventListener('keydown', onKey);
    return () => window.removeEventListener('keydown', onKey);
  }, [onClose]);

  const metadataJson = entry.metadata
    ? JSON.stringify(entry.metadata, null, 2)
    : '(aucune métadonnée)';

  return (
    <div
      className="modal__backdrop"
      role="presentation"
      onClick={(e) => {
        if (e.target === e.currentTarget) onClose();
      }}
      data-testid="audit-drawer"
    >
      <div className="modal" role="dialog" aria-modal="true" aria-labelledby="audit-drawer-title">
        <header className="modal__head">
          <h2 id="audit-drawer-title" className="display modal__title">
            Détails d'audit
          </h2>
          <button type="button" className="modal__close" onClick={onClose} aria-label="Fermer">
            ×
          </button>
        </header>

        <dl
          style={{ margin: 0, display: 'grid', gridTemplateColumns: 'auto 1fr', gap: '6px 12px' }}
        >
          <dt className="eyebrow">Action</dt>
          <dd style={{ margin: 0 }}>{entry.action}</dd>
          <dt className="eyebrow">Acteur</dt>
          <dd style={{ margin: 0 }}>
            {entry.actorDisplayName ?? entry.actorEmail ?? entry.actorUid ?? 'Système'}
          </dd>
          <dt className="eyebrow">Date</dt>
          <dd style={{ margin: 0 }}>{entry.ts}</dd>
          <dt className="eyebrow">Résultat</dt>
          <dd style={{ margin: 0 }}>{entry.outcome}</dd>
          {entry.primaryKey ? (
            <>
              <dt className="eyebrow">Facture</dt>
              <dd style={{ margin: 0, fontFamily: 'monospace', fontSize: 12 }}>
                {entry.primaryKey}
              </dd>
            </>
          ) : null}
          {entry.reason ? (
            <>
              <dt className="eyebrow">Motif</dt>
              <dd style={{ margin: 0 }} data-testid="audit-drawer-reason">
                {entry.reason}
              </dd>
            </>
          ) : null}
        </dl>

        <div className="eyebrow" style={{ marginTop: 14 }}>
          Métadonnées
        </div>
        <pre
          data-testid="audit-drawer-metadata"
          style={{
            margin: '6px 0 0',
            padding: 12,
            background: 'var(--gray-50)',
            borderRadius: 6,
            fontSize: 12,
            overflow: 'auto',
            maxHeight: 320,
          }}
        >
          {metadataJson}
        </pre>
      </div>
    </div>
  );
}
